export const GET_ROSTER_ADHERENCE = 'adherence/GET_ROSTER';
export const GET_ROSTER_ADHERENCE_SUCCESS = 'adherence/GET_ROSTER_SUCCESS';
export const GET_ROSTER_ADHERENCE_ERROR = 'adherence/GET_ROSTER_ERROR';

export const GET_CLIENT_ADHERENCE = 'adherence/GET_CLIENT';
export const GET_CLIENT_ADHERENCE_SUCCESS = 'adherence/GET_CLIENT_SUCCESS';
export const GET_CLIENT_ADHERENCE_ERROR = 'adherence/GET_CLIENT_ERROR';
